import {
  CALL_API,
  REQUEST_DELETE,
  REQUEST_GET,
  REQUEST_PUT
} from '../middleware/api'
import { NONE } from '../schemas/index'

export const CHANGE_SELECTED_VIEW = 'CHANGE_SELECTED_VIEW'
export const SEARCH_RESULTS_REQUEST = 'SEARCH_RESULTS_REQUEST'
export const SEARCH_RESULTS_SUCCESS = 'SEARCH_RESULTS_SUCCESS'
export const SEARCH_RESULTS_FAILURE = 'SEARCH_RESULTS_FAILURE'
export const SEARCH_RESULT_FAVORITE_REQUEST = 'SEARCH_RESULT_FAVORITE_REQUEST'
export const SEARCH_RESULT_FAVORITE_SUCCESS = 'SEARCH_RESULT_FAVORITE_SUCCESS'
export const SEARCH_RESULT_FAVORITE_FAILURE = 'SEARCH_RESULT_FAVORITE_FAILURE'
export const SEARCH_RESULT_UNFAVORITE_REQUEST =
  'SEARCH_RESULT_UNFAVORITE_REQUEST'
export const SEARCH_RESULT_UNFAVORITE_SUCCESS =
  'SEARCH_RESULT_UNFAVORITE_SUCCESS'
export const SEARCH_RESULT_UNFAVORITE_FAILURE =
  'SEARCH_RESULT_UNFAVORITE_FAILURE'
export const SEARCH_RESULT_UPDATE_ATTRIBUTES = 'SEARCH_RESULT_UPDATE_ATTRIBUTES'
export const SEARCH_RESULT_UPDATE_REQUEST = 'SEARCH_RESULT_UPDATE_REQUEST'
export const SEARCH_RESULT_UPDATE_SUCCESS = 'SEARCH_RESULT_UPDATE_SUCCESS'
export const SEARCH_RESULT_UPDATE_FAILURE = 'SEARCH_RESULT_UPDATE_FAILURE'
export const SEARCH_RESULT_DELETE_REQUEST = 'SEARCH_RESULT_DELETE_REQUEST'
export const SEARCH_RESULT_DELETE_SUCCESS = 'SEARCH_RESULT_DELETE_SUCCESS'
export const SEARCH_RESULT_DELETE_FAILURE = 'SEARCH_RESULT_DELETE_FAILURE'
export const TOGGLE_ALL_RESULTS = 'TOGGLE_ALL_RESULTS'
export const TOGGLE_ALL_SELECTED_RESULTS = 'TOGGLE_ALL_SELECTED_RESULTS'
export const TOGGLE_EXPAND_RESULT = 'TOGGLE_EXPAND_RESULT'
export const TOGGLE_SELECT_RESULT = 'TOGGLE_SELECT_RESULT'

export function changeSelectedView(view) {
  return {
    type: CHANGE_SELECTED_VIEW,
    view
  }
}

export function fetchSearchResults(company, searchUrl, params = {}) {
  return {
    [CALL_API]: {
      types: [
        SEARCH_RESULTS_REQUEST,
        SEARCH_RESULTS_SUCCESS,
        SEARCH_RESULTS_FAILURE
      ],
      endpoint: `companies/${company.id}/searches/${searchUrl}/results.json`,
      requestType: REQUEST_GET,
      schema: NONE,
      data: params
    }
  }
}

export function deleteResult(result) {
  return {
    result,
    [CALL_API]: {
      types: [
        SEARCH_RESULT_DELETE_REQUEST,
        SEARCH_RESULT_DELETE_SUCCESS,
        SEARCH_RESULT_DELETE_FAILURE
      ],
      endpoint: `${result.url}.json`,
      requestType: REQUEST_DELETE,
      schema: NONE
    }
  }
}

export function favoriteResult(result) {
  return {
    result,
    [CALL_API]: {
      types: [
        SEARCH_RESULT_FAVORITE_REQUEST,
        SEARCH_RESULT_FAVORITE_SUCCESS,
        SEARCH_RESULT_FAVORITE_FAILURE
      ],
      endpoint: `${result.url}/favorite.json`,
      requestType: REQUEST_PUT,
      schema: NONE
    }
  }
}

export function unfavoriteResult(result) {
  return {
    result,
    [CALL_API]: {
      types: [
        SEARCH_RESULT_UNFAVORITE_REQUEST,
        SEARCH_RESULT_UNFAVORITE_SUCCESS,
        SEARCH_RESULT_UNFAVORITE_FAILURE
      ],
      endpoint: `${result.url}/favorite.json`,
      requestType: REQUEST_DELETE,
      schema: NONE
    }
  }
}

export function toggleExpandResult(result) {
  return {
    type: TOGGLE_EXPAND_RESULT,
    result
  }
}

export function toggleAllResults(expanded) {
  return {
    type: TOGGLE_ALL_RESULTS,
    expanded
  }
}

export function toggleAllSelectedResults(selected) {
  return {
    type: TOGGLE_ALL_SELECTED_RESULTS,
    selected
  }
}

export function toggleSelectResult(result) {
  return {
    type: TOGGLE_SELECT_RESULT,
    result
  }
}

export function updateResult(result, data) {
  return {
    result,
    data,
    [CALL_API]: {
      types: [
        SEARCH_RESULT_UPDATE_REQUEST,
        SEARCH_RESULT_UPDATE_SUCCESS,
        SEARCH_RESULT_UPDATE_FAILURE
      ],
      endpoint: `${result.url}.json`,
      requestType: REQUEST_PUT,
      schema: NONE,
      data
    }
  }
}

export function updateResultAttributes(result, attributes) {
  return {
    type: SEARCH_RESULT_UPDATE_ATTRIBUTES,
    result,
    attributes
  }
}



// WEBPACK FOOTER //
// ../src/actions/searchResultActions.js